module.exports = __webpack_public_path__ + "static/img/fail.36bb2737.png";